import { LeaveApplicationContainer } from './Container';
import { LeaveApplicationContent } from './Content';
import { LeaveApplicationFooter } from './Footer';

export const LeaveApplication = {
  Container: LeaveApplicationContainer,
  Content: LeaveApplicationContent,
  Footer: LeaveApplicationFooter
}
